import { render, staticRenderFns } from "./subTask.vue?vue&type=template&id=b1a3943e&scoped=true&"
import script from "./subTask.vue?vue&type=script&lang=js&"
export * from "./subTask.vue?vue&type=script&lang=js&"
import style0 from "./subTask.vue?vue&type=style&index=0&id=b1a3943e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a3943e",
  null
  
)

export default component.exports